import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from './components/pages/Home';
import AboutUs from './components/pages/AboutUs';
import Locations from './components/pages/Locations';
import Programs from './components/pages/Programs';
import Footer from './components/layout/Footer';
import ContactUs from './components/pages/ContactUs';
import ComingSoon from './components/pages/ComingSoon';
import NavBar from './components/layout/NavBar';
import ScrollToTop from './components/layout/ScrollToTop';
import { theme } from './config/theme';
import { CssBaseline, ThemeProvider, Box } from '@mui/material';
import NotFound from './components/pages/NotFound';
import Policies from './components/pages/Policies';
import Gallery from './components/pages/Gallery';
import Bookings from './components/pages/Bookings';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        {/* Subtle noise grain overlay for visual depth on the navy background */}
        <Box
          aria-hidden="true"
          sx={{
            position: 'fixed',
            inset: 0,
            pointerEvents: 'none',
            zIndex: 0,
            opacity: 0.035,
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'repeat',
            backgroundSize: '200px 200px',
          }}
        />
        <Router>
          <ScrollToTop />
          <NavBar />
          <Box
            component="main"
            sx={{
              paddingTop: { xs: "85px", sm: "94px" },
              minHeight: "100vh",
              position: "relative",
              zIndex: 1,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 600px",
              backgroundPosition: "top center",
              backgroundImage:
                "radial-gradient(ellipse 50% 40% at 50% -20%, hsl(210, 80%, 55%), transparent)",
            }}
          >
            <Routes>
              <Route path='/' Component={Home} />
              <Route path="/about-us" Component={AboutUs} />
              <Route path="/locations" Component={Locations} />
              <Route path="/programs" Component={Programs} />
              <Route path="/contact-us" Component={ContactUs} />
              <Route path="/coming-soon" Component={ComingSoon} />
              <Route path="/policies" Component={Policies} />
              <Route path="/gallery" Component={Gallery} />
              <Route path="/bookings" Component={Bookings} />
              <Route path="/bookings/:formId" Component={Bookings} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          <Footer />
        </Router>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
